import { useCallback, useMemo, useRef } from "react";
import { APP_CONFIG } from "../config/appConfig";
import { audioEngine } from "../utils/audioEngine";

export function useAudio(muted) {
    const initialized = useRef(false);
    const mutedRef = useRef(muted);
    mutedRef.current = muted;

    const ensure = useCallback(() => {
        if (!APP_CONFIG.soundEnabled) return;
        if (!initialized.current) {
            audioEngine.init();
            audioEngine.setMuted(mutedRef.current);
            initialized.current = true;
        }
    }, []);

    const call = useCallback((name, ...args) => {
        if (!APP_CONFIG.soundEnabled) return;
        ensure();
        audioEngine[name](...args);
    }, [ensure]);

    return useMemo(() => ({
        ensureInit: ensure,
        setMuted(value) {
            mutedRef.current = value;
            if (initialized.current) audioEngine.setMuted(value);
        },
        playClick: () => call("playClick"),
        playBackspace: () => call("playBackspace"),
        playError: () => call("playError"),
        playGranted: () => call("playGranted"),
        playPowerDrop: () => call("playPowerDrop"),
        playStartup: () => call("playStartup"),
        playRelay: (delay = 0) => call("playRelay", delay),
        playPowerWave: () => call("playPowerWave"),
        playLightingSequence: () => call("playLightingSequence"),
        playMechanics: () => call("playMechanics"),
        playCoreIgnition: () => call("playCoreIgnition"),
        playProduction: () => call("playProduction"),
        playHeartbeat: () => call("playHeartbeat"),
        playFinalSync: () => call("playFinalSync"),
        startHum: () => call("startHum"),
        stopHum: () => audioEngine.stopHum()
    }), [call, ensure]);
}
